import { Redirect, useParams } from "react-router-dom";
import React, { useDispatch } from "reactn";
import Uri from "jsuri";
import jwtDecode from "jwt-decode";

// go to http://localhost:3000/tokenlogin?office=zeroq-demo&token=eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiIxMVgyR2F6TXFpVWNRU2VpQ0RwWklDNlRBRGcxIiwidXNlciI6eyJlbWFpbCI6ImN2YWxsZW5pbGxhQHplcm9xLmNsIiwibmFtZSI6IkNlc2FyIEF1Z3VzdG8iLCJpZCI6NDg1NDUsInVpZCI6IjExWDJHYXpNcWlVY1FTZWlDRHBaSUM2VEFEZzEiLCJ0eXBlIjoiYWRtaW4iLCJydXQiOiIxMjM0NTY3OC0xIiwic2x1ZyI6ImNlc2FyLWF1Z3VzdG8ifSwidXNlcl9pZCI6NDg1NDUsImlhdCI6MTU4NTA4NDc1NSwiaXNzIjoiWmVyb1EifQ.0Cm_bVEfY-BmiVuz8hN17jxVp6A2iuUpjGOFMzcAYwJayKJFZ599Cnyd6Kcn7WOcALrZL56CCiNPlxdTFvnMrg
export const TokenLogin = () => {
	const query = new Uri(window.location.href);
	const token = query.getQueryParamValue("token");
	const office = query.getQueryParamValue("office");
	const user = jwtDecode(token);
	const setUser = useDispatch("setUser");
	setUser({ ...user, ...user.user, token, isLoading: false });
	return <Redirect to={`/offices/${office}`} />;
};
